// ── ONE ADDRESS, WRITTEN ONCE ────────────────────────────────────────────
//
// The estimate sheet asked for the address twice: a "Service address" row at
// the top of the document, and the address inside the client underneath it.
// A technician standing in a driveway on a phone typed it twice, or typed it
// once and left the other blank, and when the two disagreed nothing on screen
// said which one the work was at.
//
// The row at the top is gone. The FIELD behind it is not — the project
// statement, the printed document, the list rows and the approval route all
// read serviceAddress — so it is filled from the client instead.

// Where the client is, on one line: "482 W Center St, Provo, UT 84601".
export const clientWhere = (c) => [
  [c?.address, c?.address2].filter(Boolean).join(' '),
  [c?.city, c?.state].filter(Boolean).join(', ') + (c?.zip ? ` ${c.zip}` : ''),
].map(x => String(x || '').trim()).filter(Boolean).join(', ');

// The document fields to write when a client is saved onto it.
//
// Empty when the client carries no address, so saving a customer whose
// address nobody has yet does not wipe an address already on the document.
export const serviceAddressFrom = (c) => {
  const street = String(c?.address || '').trim();
  if (!street) return {};
  return {
    serviceAddress: street,
    city: String(c?.city || '').trim(),
    state: String(c?.state || '').trim(),
    zip: String(c?.zip || '').trim(),
  };
};
